module.exports = __webpack_public_path__ + "static/img/20200518-05.4514271.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/20200518-05.png
// module id = pIX1
// module chunks = 1